import Ls from '../../../services/ls'
import * as types from './mutation-types'
import router from '../../../router/index'
import landlordAxios from '../../../services/landlordAxios'

export const login = ({ commit }, data) => {
    return new Promise((resolve, reject) => {
        landlordAxios.post('landlord/login', {
            email: data.email,
            password: data.password
        }).then((response) => {
            const token = response.data.data.token
            const admin = response.data.data.admin
            Ls.set('landlord.token', token)
            commit(types.LANDLORD_AUTH_SUCCESS, token)
            commit(types.LANDLORD_SET_ADMIN, admin)
            resolve(response)
        }).catch(err => {
            commit(types.LANDLORD_AUTH_ERROR)
            Ls.remove('landlord.token')
            reject(err)
        })
    })
}

export const me = ({ commit }) => {
    return new Promise((resolve, reject) => {
        landlordAxios.get('landlord/me').then((response) => {
            commit(types.LANDLORD_SET_ADMIN, response.data.data)
            resolve(response)
        }).catch(err => {
            reject(err)
        })
    })
}

export const logout = ({ commit }, noRequest = false) => {
    if (noRequest) {
        commit(types.LANDLORD_AUTH_LOGOUT)
        Ls.remove('landlord.token')
        router.push('/landlord/login')
        return true
    }

    return new Promise((resolve, reject) => {
        landlordAxios.post('landlord/logout').then(() => {
            commit(types.LANDLORD_AUTH_LOGOUT)
            Ls.remove('landlord.token')
            router.push('/landlord/login')
            resolve()
        }).catch(err => {
            commit(types.LANDLORD_AUTH_LOGOUT)
            Ls.remove('landlord.token')
            router.push('/landlord/login')
            reject(err)
        })
    })
}
